(function () {
  var moive = document.querySelector('.js-movie')
  if(!moive) return false

  var thumbnail = moive.querySelector('.js-movie-thumbnail')
  var player = moive.querySelector('iframe').contentWindow

  thumbnail.addEventListener('click', moviePlay)

  function moviePlay() {
    thumbnail.classList.add('is-hide')
    player.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
  }

}());
